import { render, staticRenderFns } from "./CityDetail.vue?vue&type=template&id=afdd833c&scoped=true"
import script from "./CityDetail.vue?vue&type=script&lang=js"
export * from "./CityDetail.vue?vue&type=script&lang=js"
import style0 from "./CityDetail.vue?vue&type=style&index=0&id=afdd833c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdd833c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afdd833c')) {
      api.createRecord('afdd833c', component.options)
    } else {
      api.reload('afdd833c', component.options)
    }
    module.hot.accept("./CityDetail.vue?vue&type=template&id=afdd833c&scoped=true", function () {
      api.rerender('afdd833c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/collectionOperationDashboard/component/CityDetail.vue"
export default component.exports